export const environment = {
  production: false,
  apiUrl: 'https://conntap-dev-api.crio-server.com',
  tapfiliateId: '',
};
